// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MonitorOutlinedSvg from "@fishx/icons-svg/es/asn/MonitorOutlined";
import FishxIcon from '../components/FishxIcon';

var MonitorOutlined = function MonitorOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MonitorOutlinedSvg
  }));
};

MonitorOutlined.displayName = 'MonitorOutlined';
export default React.forwardRef(MonitorOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MonitorOutlined.js
// module id = 3159
// module chunks = 0